/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-01-04 9:08:27
 *
 *******************************************************/
// @flow

import type { Action } from './store.type';

export const UPDATE_PRODUCT_PERFORMANCE_RANKING_REQUEST =
  'UPDATE_PRODUCT_PERFORMANCE_RANKING_REQUEST';
type UPDATE_PRODUCT_PERFORMANCE_RANKING_REQUEST_TYPE = 'UPDATE_PRODUCT_PERFORMANCE_RANKING_REQUEST';

export const UPDATE_PRODUCT_PERFORMANCE_RANKING_SUCCESS =
  'UPDATE_PRODUCT_PERFORMANCE_RANKING_SUCCESS';
type UPDATE_PRODUCT_PERFORMANCE_RANKING_SUCCESS_TYPE = 'UPDATE_PRODUCT_PERFORMANCE_RANKING_SUCCESS';

export const UPDATE_PRODUCT_PERFORMANCE_RANKING_FAILURE =
  'UPDATE_PRODUCT_PERFORMANCE_RANKING_FAILURE';
type UPDATE_PRODUCT_PERFORMANCE_RANKING_FAILURE_TYPE = 'UPDATE_PRODUCT_PERFORMANCE_RANKING_FAILURE';

export const GET_PRODUCT_PERFORMANCE_RANKING_REQUEST = 'GET_PRODUCT_PERFORMANCE_RANKING_REQUEST';
type GET_PRODUCT_PERFORMANCE_RANKING_REQUEST_TYPE = 'GET_PRODUCT_PERFORMANCE_RANKING_REQUEST';

export const GET_PRODUCT_PERFORMANCE_RANKING_SUCCESS = 'GET_PRODUCT_PERFORMANCE_RANKING_SUCCESS';
type GET_PRODUCT_PERFORMANCE_RANKING_SUCCESS_TYPE = 'GET_PRODUCT_PERFORMANCE_RANKING_SUCCESS';

export const GET_PRODUCT_PERFORMANCE_RANKING_FAILURE = 'GET_PRODUCT_PERFORMANCE_RANKING_FAILURE';
type GET_PRODUCT_PERFORMANCE_RANKING_FAILURE_TYPE = 'GET_PRODUCT_PERFORMANCE_RANKING_FAILURE';

export const TRIGGER_SYNC_PRODUCT_PERFORMANCE_RANKING = 'TRIGGER_SYNC_PRODUCT_PERFORMANCE_RANKING';
export const STOP_TRIGGER_SYNC_PRODUCT_PERFORMANCE_RANKING =
  'STOP_TRIGGER_SYNC_PRODUCT_PERFORMANCE_RANKING';

// Check live theme supported
type ProductPerformanceRankingSuccess = {};
type ProductPerformanceRankingFailure = {
  error: any
};
type GetProductPerformanceRankingRequestAction = Action<
  GET_PRODUCT_PERFORMANCE_RANKING_REQUEST_TYPE,
  null
>;

type GetProductPerformanceRankingSuccessAction = Action<
  GET_PRODUCT_PERFORMANCE_RANKING_SUCCESS_TYPE,
  ProductPerformanceRankingSuccess
>;

type GetProductPerformanceRankingFailureAction = Action<
  GET_PRODUCT_PERFORMANCE_RANKING_FAILURE_TYPE,
  ProductPerformanceRankingFailure
>;

type UpdateProductPerformanceRankingRequestAction = Action<
  UPDATE_PRODUCT_PERFORMANCE_RANKING_REQUEST_TYPE,
  null
>;

type UpdateProductPerformanceRankingSuccessAction = Action<
  UPDATE_PRODUCT_PERFORMANCE_RANKING_SUCCESS_TYPE,
  ProductPerformanceRankingSuccess
>;

type UpdateProductPerformanceRankingFailureAction = Action<
  UPDATE_PRODUCT_PERFORMANCE_RANKING_FAILURE_TYPE,
  ProductPerformanceRankingFailure
>;

export type ProductPerformanceRankingAction =
  | GetProductPerformanceRankingRequestAction
  | GetProductPerformanceRankingSuccessAction
  | GetProductPerformanceRankingFailureAction
  | UpdateProductPerformanceRankingRequestAction
  | UpdateProductPerformanceRankingSuccessAction
  | UpdateProductPerformanceRankingFailureAction;

export type ProductPerformanceRankingState = {
  loading: boolean,
  updating: boolean,
  settings: boolean,
  success: boolean,
  checkSyncProductPerformanceRanking: number,
  showSyncSuccess: boolean
};
